// extracted by mini-css-extract-plugin
export default {"mapCanvas":"HdpaZMbnI654TKGLKhbx"};